import Swal from "sweetalert2";
import { postRequestByAuth } from "../../../../../function/helper";
import getCompany from "../../../../shop/components/Shipments/functions/getCompany";
import getSenderAddress from "../../../../shop/components/Shipments/functions/getSenderAddress";

const avaBoxAdd = async ({
  shipments,
  setLoading,
  needSMS,
  needPrint,
  navigate,
}) => {
  const selectedCompany = getCompany();

  setLoading(true);
  const response = await postRequestByAuth("/internalpost/v1/avabox-add", {
    shipments,
    senderAddressId: getSenderAddress().id,
    needSMS,
    needPrint,
    isCod: selectedCompany.selected.isCod,
    company: {
      componyTypeId: selectedCompany.selected.componyTypeId,
      componyId: selectedCompany.selected.componyId,
      componyServicesId: selectedCompany.selected.id,
    },
  });

  if (response.status === 201) {
    Swal.fire({
      icon: "success",
      text: response.data.message,
      confirmButtonText: "مشاهده فاکتور",
    }).then(() => {
      navigate("/prefactor/" + response.data.result.map(item => item));
    });
  } else {
    setLoading(false);
    Swal.fire({
      icon: "error",
      text: response.data.message,
      confirmButtonText: "متوجه شدم",
    });
  }
};

export default avaBoxAdd;
